import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import { useAuth } from './lib/auth';
import Aanmelden from './pages/Aanmelden';
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import Gebruik from './pages/Gebruik';
import Gebruikers from './pages/Gebruikers';
import Historie from './pages/Historie';
import Landing from './pages/Landing';
import Log from './pages/Log';
import Login from './pages/Login';
import Indelen from './pages/Indelen';
import NieuwPotje from './pages/NieuwPotje';
import Poules from './pages/Poules';
import PouleDetail from './pages/PouleDetail';
import Profiel from './pages/Profiel';
import Rangen from './pages/Rangen';
import Titels from './pages/Titels';
import Ranglijst from './pages/Ranglijst';
import Rollen from './pages/Rollen';
import SpelerProfiel from './pages/SpelerProfiel';
import Statistieken from './pages/Statistieken';
import Toernooi from './pages/Toernooi';
import ToernooiDetail from './pages/ToernooiDetail';
import WachtOpGoedkeuring from './pages/WachtOpGoedkeuring';

/*
 * Drie standen, in deze volgorde:
 *
 *   niet ingelogd   — landingspagina, inloggen, aanmelden
 *   nog niet vrij   — wachtscherm; de database geeft toch niets terug
 *   binnen          — de app zelf, met per pagina de bijbehorende permissie
 */
export default function App() {
  const { klaar, ingelogd, goedgekeurd, profielBekend, mag } = useAuth();

  /* Ook wachten als het profiel nog onderweg is. Zonder dat flitst het
     wachtscherm langs bij iedereen die net inlogt — ook bij wie allang is
     vrijgegeven, want tot het profiel binnen is lijkt niemand goedgekeurd. */
  if (!klaar || (ingelogd && !profielBekend)) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-krijt-500">Bezig met laden…</div>
    );
  }

  if (!ingelogd) {
    return (
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/inloggen" element={<Login />} />
        <Route path="/aanmelden" element={<Aanmelden />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  if (!goedgekeurd) return <WachtOpGoedkeuring />;

  /* Zonder de permissie bestaat de pagina simpelweg niet voor je. */
  const met = (sleutel: string, element: JSX.Element) => (mag(sleutel) ? element : <Navigate to="/" replace />);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="overzicht" element={met('pagina.dashboard', <Dashboard />)} />
        <Route path="nieuw" element={met('pagina.nieuw', <NieuwPotje />)} />
        <Route path="indelen" element={met('pagina.nieuw', <Indelen />)} />
        <Route path="toernooi" element={met('pagina.toernooi', <Toernooi />)} />
        <Route path="toernooi/:id" element={met('pagina.toernooi', <ToernooiDetail />)} />
        <Route path="ranglijst" element={met('pagina.ranglijst', <Ranglijst />)} />
        <Route path="statistieken" element={met('pagina.statistieken', <Statistieken />)} />
        <Route path="poules" element={met('pagina.poules', <Poules />)} />
        <Route path="poules/:id" element={met('pagina.poules', <PouleDetail />)} />
        <Route path="mijn-profiel" element={<SpelerProfiel />} />
        <Route path="speler/:id" element={<SpelerProfiel />} />
        <Route path="historie" element={met('pagina.historie', <Historie />)} />
        <Route path="profiel" element={<Profiel />} />
        <Route path="titels" element={<Titels />} />
        <Route path="rangen" element={<Rangen />} />
        <Route path="gebruikers" element={met('pagina.gebruikers', <Gebruikers />)} />
        <Route path="rollen" element={met('pagina.rollen', <Rollen />)} />
        <Route path="logs" element={met('pagina.logs', <Log />)} />
        <Route path="gebruik" element={met('pagina.gebruik', <Gebruik />)} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
